
import React, { useState, useEffect, useRef } from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import { useFormik } from 'formik';

//Radio group
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

import Tooltip from '@mui/material/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import TextareaAutosize from '@mui/material/TextareaAutosize';

import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';

//Markdown
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

//copy-to-clipboard
import useCopy from "use-copy";

import { StyleSheet, css } from 'aphrodite-jss';
//import { makeStyles } from '@mui/styles';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: '90%',
    maxHeight: '92%',
    bgcolor: 'background.paper',
    borderRadius: '6px',
    border: '1px solid #fff',
    boxShadow: 24,
    p: 2,
    height: 'auto',
    //textAlign: 'center',
    overflow: 'auto'
};

export default function CustomEditor({ onUpdate, index, widget }) {

    const codeAreaRef = useRef();
    const stylesheetAreaRef = useRef();

    const [CEditStyleSheet, setCEditStyleSheet] = useState('');
    const [stylesheetError, setStylesheetError] = useState('white');
    const [text, setText] = useState('');
    const [copied, copy, setCopied] = useCopy(text);
    const copyText = () => {
        setCopied(true);
        setTimeout(() => {
            copy();
            setCopied(false);
        }, 500);
    };

    const arrTypeOf = ['HTML', 'Markdown', 'Text'];
    const dataDefault = {
        name: '',
        typeOf: arrTypeOf[0],
        text: '',
        textStylesheet: '',
        hide: '',
    };
    const isInModification = widget[0]?.data && (Object.keys(widget[0]?.data)?.length > 0);

    //Mui Modal
    const [openModal, setOpenModal] = useState(false);
    const handleOpen = () => setOpenModal(true);
    //const handleClose = () => setOpenModal(false);

    useEffect(() => {
        handleOpen();
        //console.log(widget[0].data, isInModification);
    }, []);

    //Formik
    const formik = useFormik({
        initialValues: isInModification ? widget[0].data : dataDefault,
        enableReinitialize: true,
        onSubmit: values => {
            alert(JSON.stringify(values, null, 2));
        },
    });

    useEffect(() => {
        try {
            setStylesheetError('white');
            if (formik.values?.textStylesheet) {
                let txt = JSON.parse(formik.values?.textStylesheet);
                setCEditStyleSheet(StyleSheet.create(
                    { classMainSS: txt }
                ));
            }
        } catch (error) {
            console.error(error)
            setStylesheetError('#ffc107');
        }
    }, [formik.values?.textStylesheet]);

    //console.log('CEditStyleSheet: ', CEditStyleSheet)

    //Gestione chiusura del modal
    function handleClose(event, reason) {
        //console.log(event, reason);
        switch (reason) {
            case 'backdropClick':
                return;
            case 'escapeKeyDown':
                return;
            default:
                setOpenModal(false);
        }
    }

    const handleChangeCBhide = (event) => {
        formik.setFieldValue('hide', event.target.checked);
    };

    const handleChange = (event) => {
        formik.setFieldValue('typeOf', event.target.value);
        //console.log(event.target.value)
    };

    return (
        <>
            <Modal
                aria-labelledby="ch-modal-title"
                aria-describedby="ch-modal-description"
                open={openModal}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            //disableEscapeKeyDown={true} 
            >
                <Fade in={openModal}>
                    <Box sx={style}>
                        <Typography id="ch-modal-title" variant="h6" component="h2"
                            style={{ marginBottom: "10px", textAlign: "center" }}>
                            {isInModification ? 'Custom Editor' : 'New Custom Editor'}
                        </Typography>
                        <div className="container-fluid">
                            <div className="row m-1">
                                <div className="col-1 p-2">
                                    <FormGroup aria-label="hide" row>
                                        <FormControlLabel
                                            sx={{ margin: "0px" }}
                                            value="start"
                                            control={
                                                <Checkbox
                                                    checked={formik.values?.hide || false}
                                                    onChange={(event) => handleChangeCBhide(event)}
                                                    inputProps={{ 'aria-label': 'controlled' }}
                                                />
                                            }
                                            label="Hidden"
                                            labelPlacement="start" />
                                    </FormGroup>
                                </div>
                                <div className="col-11 p-2">
                                    <input type="text" id="name" className="form-control" style={{ width: "100%" }}
                                        placeholder="Custom widget name"
                                        onChange={formik.handleChange}
                                        value={formik.values?.name}
                                    />
                                </div>
                            </div>

                            <div className="row m-1">
                                <div className="col-8 p-2">

                                    <div style={{ color: "#1976d2", textAlign: "center" }}>Scrivi il codice in base al 'Type Of' selezionato</div>

                                    <div className="row m-1" style={{ textAlign: "center", backgroundColor: "#e9ecef", minHeight: "106px" }}>
                                        <div className="col-2 p-2 ">
                                            <button type="button" className="btn btn-sm btn-light"
                                                style={{ minWidth: "180px", float: "left" }}
                                                onClick={() => {
                                                    setText(formik.values?.text);
                                                    copyText();
                                                }}
                                                title="Copia il codice">
                                                {copied ? <span style={{ verticalAlign: "text-bottom", padding: "6px" }}>Code copied</span>
                                                    : <span style={{ verticalAlign: "text-bottom", padding: "6px" }}>Copy code</span>}
                                                <FontAwesomeIcon
                                                    sx={{ padding: "2px" }}
                                                    icon={['fas', 'clipboard']}
                                                    title=""
                                                    size={'1x'}
                                                    color={'#6c757d'}
                                                />
                                            </button>
                                        </div>
                                        <div className="col-8 p-2">
                                            <FormControl>
                                                <FormLabel id="type-form-control-label-placement">Type Of</FormLabel>
                                                <RadioGroup
                                                    row
                                                    aria-labelledby="type-form-control-label-placement"
                                                    name="custom editor widget"
                                                >
                                                    {arrTypeOf?.map((e, i) => {
                                                        return <FormControlLabel
                                                            key={i}
                                                            control={
                                                                <Tooltip title={i === 1 ? 'Selezionando Markdown puoi scrivere unendo anche codice HTML. Clicca in basso su StackEdit per accedere all\'editor' : ''}>
                                                                    <Radio
                                                                        checked={e === formik.values.typeOf}
                                                                        onChange={handleChange}
                                                                        value={e}
                                                                    />
                                                                </Tooltip>
                                                            }
                                                            label={e}
                                                            labelPlacement="bottom"
                                                        />
                                                    })}
                                                </RadioGroup>
                                            </FormControl>
                                        </div>
                                        <div className="col-2 p-2 ">
                                            <button type="button" className="btn btn-sm btn-light"
                                                style={{ minWidth: "180px", float: "right" }}
                                                onClick={() => {
                                                    formik.setFieldValue('text', '');
                                                }}
                                                title="Clear textarea">
                                                <span style={{ verticalAlign: "text-bottom", padding: "6px" }}>Clear textarea</span>
                                                <FontAwesomeIcon
                                                    sx={{ padding: "2px" }}
                                                    icon={['fas', 'trash']}
                                                    title=""
                                                    size={'1x'}
                                                    color={'#6c757d'}
                                                />
                                            </button>
                                        </div>
                                    </div>

                                    <div className="row" style={{ textAlign: "center" }}>
                                        <div className="col-12 p-2">
                                            <TextareaAutosize
                                                id='text'
                                                autoFocus
                                                ref={codeAreaRef}
                                                maxRows={12}
                                                minRows={12}
                                                aria-label="typeof textarea"
                                                placeholder="Empty"
                                                onChange={formik.handleChange}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Tab') {
                                                        e.preventDefault();
                                                        codeAreaRef.current.focus();
                                                        return;
                                                    }
                                                }}
                                                value={formik.values?.text}
                                                style={{ width: "100%" }}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 p-2">
                                            {formik.values?.typeOf !== "Text" &&
                                                <Accordion>
                                                    <AccordionSummary
                                                        expandIcon={<FontAwesomeIcon
                                                            sx={{ padding: "2px" }}
                                                            icon={['fas', 'angle-down']}
                                                            title=""
                                                            size={'1x'}
                                                            color={'#6c757d'}
                                                        />}

                                                        aria-controls="panel1a-content"
                                                        id="panel1a-header"
                                                    >
                                                        <Typography>Preview</Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <div style={{
                                                            maxHeight: "520px",
                                                            overflow: "auto"
                                                        }}>
                                                            <ReactMarkdown
                                                                skipHtml={false}
                                                                //escapeHtml={false}
                                                                className={css(CEditStyleSheet.classMainSS)}
                                                                rehypePlugins={[rehypeRaw]}
                                                                remarkPlugins={[remarkGfm]}
                                                                children={formik.values?.text}
                                                            />
                                                        </div>
                                                    </AccordionDetails>
                                                </Accordion>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="col-4 p-2">
                                    <div style={{ color: "#1976d2", textAlign: "center" }}>Codice Stylesheet</div>
                                    <div className="row m-1" style={{ textAlign: "center", backgroundColor: "#e9ecef", minHeight: "106px" }}>
                                        <div className="col-6 p-2 ">
                                            <button type="button" className="btn btn-sm btn-light"
                                                style={{ minWidth: "150px", float: "left" }}
                                                onClick={() => {
                                                    setText(formik.values?.textStylesheet);
                                                    copyText();
                                                }}
                                                title="Copia stylesheet">
                                                {copied ? <span style={{ verticalAlign: "text-bottom", padding: "4px" }}>Stylesheet copied</span>
                                                    : <span style={{ verticalAlign: "text-bottom", padding: "4px" }}>Copy stylesheet</span>}
                                                <FontAwesomeIcon
                                                    sx={{ padding: "2px" }}
                                                    icon={['fas', 'clipboard']}
                                                    title=""
                                                    size={'1x'}
                                                    color={'#6c757d'}
                                                />
                                            </button>
                                        </div>

                                        <div className="col-6 p-2 ">
                                            <button type="button" className="btn btn-sm btn-light"
                                                style={{ minWidth: "100px", float: "right" }}
                                                onClick={() => {
                                                    formik.setFieldValue('textStylesheet', '');
                                                }}
                                                title="Clear textarea">
                                                <span style={{ verticalAlign: "text-bottom", padding: "6px" }}>Clear textarea</span>
                                                <FontAwesomeIcon
                                                    sx={{ padding: "2px" }}
                                                    icon={['fas', 'trash']}
                                                    title=""
                                                    size={'1x'}
                                                    color={'#6c757d'}
                                                />
                                            </button>
                                        </div>
                                    </div>
                                    <div style={{
                                        padding: "0.5rem",
                                        height: "74%"
                                    }}>
                                        <TextareaAutosize
                                            id='textStylesheet'
                                            ref={stylesheetAreaRef}
                                            //maxRows={12}
                                            //minRows={12}
                                            aria-label="typeof textStylesheet"
                                            placeholder="Empty"
                                            onChange={formik.handleChange}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Tab') {
                                                    e.preventDefault();
                                                    stylesheetAreaRef.current.focus();
                                                    return;
                                                }
                                            }}
                                            value={formik.values?.textStylesheet}
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                overflow: "auto",
                                                backgroundColor: stylesheetError
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{ textAlign: "center" }}>
                            <div className="col-12">
                                {formik.values?.typeOf === "Markdown" &&
                                    <a type="button" href={'https://stackedit.io/app#'} style={{ minWidth: "15%", padding: "2px", marginTop: "4px" }}
                                        className="my-tooltip btn btn-light" title="Apri StackEdit" target="_blank" rel="noopener noreferrer">
                                        StackEdit
                                    </a>
                                }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                                <button type="button" className="btn btn-secondary"
                                    style={{ minWidth: '6rem', marginLeft: '10px', float: "left" }}
                                    onClick={() => { ((widget[0]?.data && isInModification) ? onUpdate(null, -1) : onUpdate(null, index)); handleClose(); }}>
                                    Chiudi
                                </button>
                            </div>
                            <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                                {/* {formik.values?.text?.length ? */}
                                <button type="button" className="btn btn-success"
                                    style={{ minWidth: '6rem', marginRight: '10px', float: "right" }}
                                    onClick={() => { onUpdate(formik.values, index); handleClose(); }}>
                                    Conferma
                                </button>
                                {/* : ''} */}
                            </div>
                        </div>
                    </Box>
                </Fade>
            </Modal>
        </>
    );
}